import { SQLITE_TABLE_PUSH_LOGS } from '@1bill-app/constants';
import { SQLiteService } from '@1bill-app/services/sqlite/sqlite.service';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AlertController } from '@ionic/angular';

@Component({
  selector: 'app-push-logs',
  templateUrl: './push-logs.page.html',
  styleUrls: ['./push-logs.page.scss'],
})
export class PushLogsPage implements OnInit {
  offset = 0;
  pushLogs = [];
  totalCount: number;

  constructor(
    private sqlite: SQLiteService,
    private alertCtrl: AlertController,
    private cdr: ChangeDetectorRef,
  ) { }

  async ngOnInit() {
    if (this.sqlite.db) {
      this.totalCount = await this.getPushLogCount();
      this.loadPushLogs();
    }
  }

  async reload() {
    this.pushLogs = [];
    this.offset = 0;
    if (this.sqlite.db) {
      this.totalCount = await this.getPushLogCount();
      this.loadPushLogs();
    }
  }

  async loadPushLogs() {
    const limit = 25;
    const statement = `
      SELECT * FROM ${SQLITE_TABLE_PUSH_LOGS} 
      ORDER BY timestamp DESC
      LIMIT ${limit} 
      OFFSET ${limit * this.offset}
      ;
    `;

    const { values } = await this.sqlite.query({ statement });
    values.forEach(v => this.pushLogs.push(v));
    this.offset = this.offset + 1;
    this.cdr.detectChanges();
  }

  async loadEvent(event: any) {

    await this.loadPushLogs();
    event.target.complete();
    // App logic to determine if all data is loaded
    // and disable the infinite scroll
    if (this.pushLogs.length >= this.totalCount) {
      event.target.disabled = true;
    }
  }

  async getPushLogCount() {
    const statement = `SELECT COUNT(*) as count FROM ${SQLITE_TABLE_PUSH_LOGS}`;
    const { values } = await this.sqlite.query({ statement });

    return values[0].count as number;
  }

  async clearLogs() {
    const alert = await this.alertCtrl.create({
      header: 'Clear push logs?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
        }, {
          text: 'Okay',
          handler: async () => {
            const statement = `DELETE FROM ${SQLITE_TABLE_PUSH_LOGS}`;
            await this.sqlite.run({ statement });
            this.reload();
          }
        }
      ]
    });
    await alert.present();
  }
}
